<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="breadcrumb-title border-0 mb-3">
        <div
          class="d-flex justify-content-between align-items-center flex-wrap"
        >
          <div class="d-flex align-items-center">
            <mat-icon color="primary">dashboard_customize</mat-icon>
            <p class="ms-2 mb-0">{{ "APPLICATIONS.TITLE" | translate }}</p>
          </div>
          <div class="p-0 m-0">
            <app-list-header [$parent]="getSelf()"></app-list-header>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <div class="card border-0" style="min-height: 480px">
        <div class="card-body">
          <div class="row">
            <div class="col-auto mb-2 px-1">
              <div class="compact-inputs">
                <mat-form-field
                  appearance="outline"
                  class="d-flex dropdown-pd-none app-search-width"
                >
                  <mat-label>{{
                    "ALLREMAININGS.Search_App_Name" | translate
                  }}</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="form.searchParams['name']"
                  />
                  <button
                    mat-stroked-button
                    matSuffix
                    [disabled]="!form.searchParams['name']"
                    (click)="search1()"
                    [matTooltip]="'COMMON.SEARCH' | translate"
                    matTooltipPosition="above"
                    class="icon-center icon-width rounded-0 fs-5"
                  >
                    <i class="bx bx-search"></i>
                  </button>
                </mat-form-field>
              </div>
            </div>
            <div class="col-auto mb-2 px-1">
              <button
                mat-stroked-button
                color="primary"
                (click)="resetSearch()"
                [matTooltip]="'COMMON.RESET' | translate"
                matTooltipPosition="above"
              >
                <i class="fa fa-eraser"></i>
                <span class="ms-2">{{ "COMMON.RESET" | translate }}</span>
              </button>
            </div>
            <div class="col-auto mb-2 px-1">
              <button
                mat-stroked-button
                color="primary"
                data-bs-toggle="modal"
                data-bs-target="#editModal"
                [matTooltip]="'COMMON.ADD' | translate"
                (click)="get(0)"
                matTooltipPosition="above"
              >
                <mat-icon>add</mat-icon>
                <span>{{ "COMMON.ADD" | translate }}</span>
              </button>
            </div>
            <div class="col-auto mb-2 px-1">
              <div class="d-flex align-items-center gap-2">
                <button
                  *ngIf="!isArchiveActive"
                  mat-stroked-button
                  color="primary"
                  [matTooltip]="'APPLICATIONS.ARCHIVE' | translate"
                  (click)="toggleTab('archived'); searchArchived()"
                  matTooltipPosition="above"
                >
                  <mat-icon>archive</mat-icon>
                  <span>{{ "APPLICATIONS.ARCHIVE" | translate }}</span>
                </button>
                <button
                  *ngIf="isArchiveActive"
                  mat-stroked-button
                  color="primary"
                  [matTooltip]="'APPLICATIONS.MAIN_LIST' | translate"
                  (click)="toggleTab('main')"
                  matTooltipPosition="above"
                >
                  <mat-icon>list</mat-icon>
                  <span>{{ "APPLICATIONS.MAIN_LIST" | translate }}</span>
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 px-1">
              <div class="tab-content mt-3" id="pills-tabContent">
                <div
                  class="tab-pane fade"
                  [class.show]="!isArchiveActive"
                  [class.active]="!isArchiveActive"
                  id="pills-main"
                  role="tabpanel"
                  aria-labelledby="pills-main-tab"
                >
                  <div class="mb-3">
                    <div>
                      <p
                        *ngIf="
                          form['searchError'] == false && form['searchMessage']
                        "
                      >
                        <app-ncs-alert
                          [message]="form['searchMessage']"
                          type="success"
                        />
                      </p>
                      <p
                        *ngIf="
                          form['searchError'] == true && form['searchMessage']
                        "
                      >
                        <app-ncs-alert
                          [message]="form['searchMessage']"
                          type="danger"
                        />
                      </p>
                    </div>
                    <div class="table-container mb-3">
                      <div class="table-responsive table-scrollable">
                        <table class="table table-bordered table-sticky-header">
                          <thead>
                            <tr>
                              <th class="text-center">
                                {{ "COMMON.SNO" | translate }}
                              </th>

                              <th class="text-nowrap sortable-header">
                                <span
                                  class="header-label"
                                  (click)="sortTable('name')"
                                >
                                  {{ "COMMON.NAME" | translate }}
                                  <ng-container
                                    *ngTemplateOutlet="
                                      sortIcons;
                                      context: { key: 'name' }
                                    "
                                  ></ng-container>
                                </span>
                              </th>
                              <th>{{ "COMMON.ACTIONS" | translate }}</th>
                            </tr>

                            <!-- Sort Icons -->
                            <ng-template #sortIcons let-key="key">
                              <i
                                *ngIf="
                                  sortedField === key && sortOrder === 'ASC'
                                "
                                class="fa fa-sort-up ms-1 text-dark"
                              ></i>
                              <i
                                *ngIf="
                                  sortedField === key && sortOrder === 'DESC'
                                "
                                class="fa fa-sort-down ms-1 text-dark"
                              ></i>
                              <i
                                *ngIf="sortedField !== key"
                                class="fa fa-sort ms-1 text-muted"
                              ></i>
                            </ng-template>
                          </thead>
                          <tbody>
                            <tr *ngFor="let e of form.list; let i = index">
                              <td class="text-center">{{ pageIndex(i) }}</td>
                              <td class="align-middle">
                                <div class="d-flex align-items-center">
                                  <!-- Logo Card -->
                                  <div class="me-3">
                                    <div
                                      class="p-1 border rounded d-flex justify-content-center align-items-center"
                                      style="
                                        width: 40px;
                                        height: 40px;
                                        overflow: hidden;
                                      "
                                    >
                                      <a
                                        [href]="getDoc(e['logo'])"
                                        target="_blank"
                                        class="d-block"
                                        [matTooltip]="e.name"
                                        matTooltipPosition="above"
                                      >
                                        <img
                                          [src]="getDocThumbnail(e['logo'])"
                                          [alt]="
                                            e.name ||
                                            ('COMMON.IMAGE_PREVIEW' | translate)
                                          "
                                          class="w-100 h-100"
                                          style="object-fit: cover"
                                        />
                                      </a>
                                    </div>
                                  </div>
                                  <div>
                                    <!-- Application Name with Icon -->
                                    <div class="d-flex align-items-center">
                                      <mat-icon
                                        color="primary"
                                        class="p-0"
                                        style="font-size: 14px; height: auto"
                                        >dashboard_customize</mat-icon
                                      >
                                      <p style="font-weight: 500" class="mb-0">
                                        {{ truncate(e.name, 30) }}
                                      </p>
                                    </div>
                                    <!-- URL with Chip -->
                                    <div class="d-flex align-items-center">
                                      <mat-icon
                                        color=""
                                        class="p-0 text-muted"
                                        style="font-size: 14px; height: auto"
                                        >link</mat-icon
                                      >
                                      <small
                                        class="text-truncate text-muted"
                                        style="max-width: 180px"
                                        >{{ e.appUrl }}</small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="d-flex gap-2">
                                  <!-- API Button -->
                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    matTooltipPosition="above"
                                    [matTooltip]="
                                      'APPLICATIONS.API' | translate
                                    "
                                    (click)="goto(e.id)"
                                  >
                                    <i class="bx bx-network-chart"></i>
                                    <small>
                                      {{
                                        "APPLICATIONS.API" | translate
                                      }}</small
                                    >
                                  </button>

                                  <!-- Role Button -->
                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    matTooltipPosition="above"
                                    [matTooltip]="
                                      'APPLICATIONS.ROLES' | translate
                                    "
                                    data-bs-toggle="modal"
                                    data-bs-target="#appRoleModal"
                                    (click)="setApp(e, 'app-role')"
                                  >
                                    <small class="me-1">
                                      {{
                                        "APPLICATIONS.ROLES" | translate
                                      }}</small
                                    >
                                    <mat-icon>group</mat-icon>
                                  </button>

                                  <!-- Role Access Button -->
                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    matTooltipPosition="above"
                                    [matTooltip]="
                                      'APPLICATIONS.ACCESS' | translate
                                    "
                                    data-bs-toggle="modal"
                                    data-bs-target="#appRoleUsecaseModal"
                                    (click)="setApp(e, 'app-role-usecase')"
                                  >
                                    <mat-icon>lock</mat-icon>
                                    <small>
                                      {{
                                        "APPLICATIONS.ACCESS" | translate
                                      }}</small
                                    >
                                  </button>

                                  <!-- Menu Button -->
                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    matTooltipPosition="above"
                                    [matTooltip]="
                                      'APPLICATIONS.MENU' | translate
                                    "
                                    (click)="setApp(e, 'app-menus')"
                                    [routerLink]="['/menuslist/' + e.id]"
                                  >
                                    <mat-icon>menu_open</mat-icon>
                                    <small>
                                      {{
                                        "APPLICATIONS.MENU" | translate
                                      }}</small
                                    >
                                  </button>

                                  <!-- App Users Button -->
                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    matTooltipPosition="above"
                                    [matTooltip]="
                                      'APPLICATIONS.USERS' | translate
                                    "
                                    [routerLink]="['/applicationUser/' + e.id]"
                                  >
                                    <mat-icon>group_add</mat-icon>
                                    <small>
                                      {{
                                        "APPLICATIONS.USERS" | translate
                                      }}</small
                                    >
                                  </button>

                                  <!-- UI Forms Button -->
                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    matTooltipPosition="above"
                                    [matTooltip]="
                                      'APPLICATIONS.UI_FORMS' | translate
                                    "
                                    [routerLink]="['/uiallformlist', e.id]"
                                  >
                                    <mat-icon>description</mat-icon>
                                    <small>{{
                                      "APPLICATIONS.UI_FORMS" | translate
                                    }}</small>
                                  </button>

                                  <!-- Reports Button -->
                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    matTooltipPosition="above"
                                    [matTooltip]="
                                      'APPLICATIONS.REPORTS' | translate
                                    "
                                    [routerLink]="['/reportslist', e.id]"
                                  >
                                    <mat-icon>assessment</mat-icon>
                                    <small>{{
                                      "APPLICATIONS.REPORTS" | translate
                                    }}</small>
                                  </button>

                                  <!-- settings Button -->
                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    class="d-flex align-items-center advancfont"
                                    [matMenuTriggerFor]="advanceMenu"
                                    [matTooltip]="'COMMON.SETTINGS' | translate"
                                    matTooltipPosition="above"
                                    type="button"
                                  >
                                    <div class="d-flex align-items-center">
                                      <mat-icon class="icon-compact"
                                        >settings</mat-icon
                                      >
                                      <span class="ms-2">{{
                                        "COMMON.SETTINGS" | translate
                                      }}</span>
                                      <mat-icon class="dropdown-chevron"
                                        >arrow_drop_down</mat-icon
                                      >
                                    </div>
                                  </button>

                                  <mat-menu
                                    #advanceMenu="matMenu"
                                    class="advance-dropdown-panel scrollable-menu"
                                  >
                                    <button
                                      mat-menu-item
                                      (click)="gotourules(e.id)"
                                    >
                                      <mat-icon color="primary">rule</mat-icon>
                                      <span>{{
                                        "APPLICATIONS.API_RULES" | translate
                                      }}</span>
                                    </button>

                                    <button
                                      mat-menu-item
                                      (click)="setApp(e, 'collaborator')"
                                      data-bs-toggle="modal"
                                      data-bs-target="#developerModal"
                                    >
                                      <mat-icon color="primary"
                                        >person_add</mat-icon
                                      >
                                      <span>{{
                                        "APPLICATIONS.COLLABORATOR" | translate
                                      }}</span>
                                    </button>

                                    <button
                                      mat-menu-item
                                      (click)="delete(e.id)"
                                    >
                                      <mat-icon color="primary"
                                        >archive</mat-icon
                                      >
                                      <span>{{
                                        "APPLICATIONS.ARCHIVE" | translate
                                      }}</span>
                                    </button>

                                    <button
                                      mat-menu-item
                                      (click)="copyAppURL(e, $event, i)"
                                    >
                                      <mat-icon
                                        color="primary"
                                        *ngIf="!copied || activeIndex != i"
                                        >content_copy</mat-icon
                                      >
                                      <mat-icon
                                        color="primary"
                                        *ngIf="copied && activeIndex === i"
                                        >check</mat-icon
                                      >
                                      <span>
                                        {{
                                          copied && activeIndex === i
                                            ? ("COMMON.COPIED" | translate)
                                            : ("APPLICATIONS.APP_URL"
                                              | translate)
                                        }}
                                      </span>
                                    </button>

                                    <button
                                      mat-menu-item
                                      [routerLink]="'/usecaseDatabase/' + e.id"
                                    >
                                      <mat-icon color="primary"
                                        >storage</mat-icon
                                      >
                                      <span>{{
                                        "APPLICATIONS.DATABASE" | translate
                                      }}</span>
                                    </button>

                                    <button
                                      mat-menu-item
                                      [routerLink]="
                                        '/applicationConfiguration/' + e.id
                                      "
                                    >
                                      <mat-icon color="primary">dns</mat-icon>
                                      <span>{{
                                        "APPLICATIONS.CONFIGURATION" | translate
                                      }}</span>
                                    </button>
                                  </mat-menu>

                                  <button
                                    mat-stroked-button
                                    color="warn"
                                    [matTooltip]="'COMMON.EDIT' | translate"
                                    matTooltipPosition="above"
                                    [routerLink]="['/applicationInfo', e.id]"
                                    (click)="
                                      get(e.id);
                                      imagePreviewReset();
                                      checkDefaultLogin()
                                    "
                                  >
                                    <mat-icon>edit</mat-icon>
                                    <small>
                                      {{ "COMMON.EDIT" | translate }}</small
                                    >
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div>
                      <app-list-header [$parent]="getSelf()"></app-list-header>
                    </div>
                  </div>
                </div>

                <!-- Archived Applications Tab -->
                <div
                  class="tab-pane fade"
                  [class.show]="isArchiveActive"
                  [class.active]="isArchiveActive"
                  id="pills-archived"
                  role="tabpanel"
                  aria-labelledby="pills-archived-tab"
                >
                  <div class="mb-3">
                    <div>
                      <p
                        *ngIf="
                          form['searchError'] == false && form['searchMessage']
                        "
                      >
                        <app-ncs-alert
                          [message]="form['searchMessage']"
                          type="success"
                        />
                      </p>
                      <p
                        *ngIf="
                          form['searchError'] == true && form['searchMessage']
                        "
                      >
                        <app-ncs-alert
                          [message]="form['searchMessage']"
                          type="danger"
                        />
                      </p>
                    </div>
                    <div class="table-container mb-3">
                      <div class="table-responsive table-scrollable">
                        <table class="table table-bordered table-sticky-header">
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 5%">
                                {{ "COMMON.SNO" | translate }}
                              </th>
                              <th class="text-nowrap sortable-header">
                                <span
                                  class="header-label"
                                  (click)="sortTable('name')"
                                >
                                  {{ "COMMON.NAME" | translate }}
                                  <ng-container
                                    *ngTemplateOutlet="
                                      sortIcons;
                                      context: { key: 'name' }
                                    "
                                  ></ng-container>
                                </span>
                              </th>

                              <th>{{ "COMMON.ACTIONS" | translate }}</th>
                            </tr>

                            <!-- Sort Icons Template -->
                            <ng-template #sortIcons let-key="key">
                              <i
                                *ngIf="
                                  sortedField === key && sortOrder === 'ASC'
                                "
                                class="fa fa-sort-up ms-1 text-dark"
                              ></i>
                              <i
                                *ngIf="
                                  sortedField === key && sortOrder === 'DESC'
                                "
                                class="fa fa-sort-down ms-1 text-dark"
                              ></i>
                              <i
                                *ngIf="sortedField !== key"
                                class="fa fa-sort ms-1 text-muted"
                              ></i>
                            </ng-template>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="let e of form.archivedlist; let i = index"
                            >
                              <td class="text-center" style="width: 5%">
                                {{ pageIndex(i) }}
                              </td>
                              <td>
                                <div class="d-flex align-items-center">
                                  <div class="me-3">
                                    <div
                                      class="p-1 border rounded"
                                      style="
                                        width: 40px;
                                        height: 40px;
                                        overflow: hidden;
                                      "
                                    >
                                      <a
                                        [href]="getDoc(e['logo'])"
                                        target="_blank"
                                        class="d-block h-100"
                                        [matTooltip]="e.name"
                                        matTooltipPosition="above"
                                      >
                                        <img
                                          [src]="getDocThumbnail(e['logo'])"
                                          [alt]="
                                            e.name ||
                                            ('COMMON.IMAGE_PREVIEW' | translate)
                                          "
                                          class="w-100 h-100"
                                          style="object-fit: cover"
                                        />
                                      </a>
                                    </div>
                                  </div>
                                  <div>
                                    <div class="d-flex align-items-center">
                                      <mat-icon
                                        color="primary"
                                        class="p-0 me-1"
                                        style="font-size: 14px; height: auto"
                                        >dashboard_customize</mat-icon
                                      >
                                      <p style="font-weight: 500" class="mb-0">
                                        {{ e.name }}
                                      </p>
                                    </div>

                                    <div class="d-flex align-items-center">
                                      <mat-icon
                                        color="primary"
                                        class="p-0 me-1 text-muted"
                                        style="font-size: 14px; height: auto"
                                        >link</mat-icon
                                      >
                                      <small
                                        class="text-truncate text-muted"
                                        style="max-width: 180px"
                                        >{{ e.appUrl }}</small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  [matTooltip]="
                                    'APPLICATIONS.RETRIEVE' | translate
                                  "
                                  matTooltipPosition="above"
                                  (click)="retrieve(e.id)"
                                >
                                  <mat-icon>unarchive</mat-icon>
                                  <span class="ms-1">{{
                                    "APPLICATIONS.RETRIEVE" | translate
                                  }}</span>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <app-list-header [$parent]="getSelf()"></app-list-header>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Application Edit Modal -->
<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.APPLICATION" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
          (click)="imagePreviewReset()"
        ></button>
      </div>
      <div class="modal-body">
        <form #uiForm="ngForm">
          <div>
            <p *ngIf="form['error'] == false && form['message']">
              <app-ncs-alert [message]="form['message']" type="success" />
            </p>
            <p *ngIf="form['error'] == true && form['message']">
              <app-ncs-alert [message]="form['message']" type="danger" />
            </p>
          </div>
          <div class="row compact-inputs dropdown-pd-none">
            <!-- Name Field -->
            <div class="col-12 mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ "COMMON.NAME" | translate }}</mat-label>
                <input
                  matInput
                  (input)="checkValue($event)"
                  id="name"
                  name="name"
                  type="text"
                  required
                  [(ngModel)]="form.data['name']"
                  #nameInput="ngModel"
                />
              </mat-form-field>
              <mat-error *ngIf="form.inputerror['name']">
                {{ form.inputerror["name"] }}
              </mat-error>
            </div>

            <!-- Subdomain Field -->
            <div class="col-12 mb-3">
              <mat-form-field
                appearance="outline"
                class="w-100"
                floatLabel="always"
              >
                <span matPrefix class="ps-2 prefixhttp">https://</span>
                <mat-label>{{
                  "COMMON.URL_PLACEHOLDER" | translate
                }}</mat-label>
                <input
                  matInput
                  name="subdomain"
                  required
                  [(ngModel)]="form.data['subdomain']"
                  (ngModelChange)="onSubdomainChange($event)"
                />
                <span matSuffix class="pe-2 prefixhttp">{{ BASE_DOMAIN }}</span>
              </mat-form-field>
              <mat-error *ngIf="form.inputerror['appUrl']">
                {{ form.inputerror["appUrl"] }}
              </mat-error>
            </div>

            <!-- Domain Field -->
            <div class="col-12 mb-3">
              <div class="d-flex gap-1 align-items-center">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{
                    "COMMON.DOMAIN_PLACEHOLDER" | translate
                  }}</mat-label>

                  <input
                    matInput
                    id="domainUrl"
                    name="domainUrl"
                    type="url"
                    [(ngModel)]="form.data['domainUrl']"
                    #domainUrlInput="ngModel"
                  />

                  <mat-icon
                    matSuffix
                    class="text-secondary ms-1 cursor icon-pd-none"
                    [matTooltip]="'COMMON.DOMAIN_TOOLTIP' | translate"
                  >
                    info
                  </mat-icon>
                </mat-form-field>
              </div>
              <mat-error *ngIf="form.inputerror['domainUrl']">
                {{ form.inputerror["domainUrl"] }}
              </mat-error>
            </div>

            <!-- Status Field -->
            <div class="col-12 mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ "COMMON.STATUS" | translate }}</mat-label>
                <mat-select
                  [(ngModel)]="form.data['status']"
                  id="status"
                  name="status"
                >
                  <mat-option value="undefined" disabled selected>
                    {{ "COMMON.SELECT" | translate }}
                  </mat-option>
                  <mat-option value="private">
                    {{ "APPLICATIONS.STATUS.PRIVATE" | translate }}
                  </mat-option>
                  <mat-option value="public">
                    {{ "APPLICATIONS.STATUS.PUBLIC" | translate }}
                  </mat-option>
                  <mat-option value="draft">
                    {{ "APPLICATIONS.STATUS.DRAFT" | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <!-- Code Field (readonly for existing apps) -->
          <div class="row mb-3" *ngIf="form.data['id'] > 0">
            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ "COMMON.CODE" | translate }}</mat-label>
                <input
                  matInput
                  [disabled]="true"
                  [(ngModel)]="form.data['code']"
                  type="text"
                  id="code"
                  name="code"
                  [placeholder]="'COMMON.CODE' | translate"
                />
              </mat-form-field>
            </div>
          </div>

          <!-- extra field shift to edit page -->
          <div>
            <!-- Code Field (readonly for existing apps) -->
            <div class="row mb-3" *ngIf="form.data['id'] > 0">
              <div class="col"></div>
              <label for="code" class="col col-form-label"
                >{{ "COMMON.CODE" | translate }} :</label
              >
              <div class="col-sm-7">
                <input
                  [disabled]="true"
                  [(ngModel)]="form.data['code']"
                  type="text"
                  class="form-control form-control-sm"
                  id="code"
                  name="code"
                  [placeholder]="'COMMON.CODE' | translate"
                />
              </div>
              <div class="col"></div>
            </div>

            <!-- Logo Upload (for existing apps) -->
            <div class="row mb-3" *ngIf="form.data['id'] > 0">
              <div class="col"></div>
              <label for="logo" class="col col-form-label"
                >{{ "COMMON.LOGO" | translate }} :</label
              >
              <div class="col-sm-7">
                <input
                  class="form-control"
                  id="logo"
                  #file
                  type="file"
                  accept="image/*"
                  name="logo"
                  (change)="
                    file.files &&
                      onFileChanged($event, 'logo', form.data['logo'])
                  "
                />
                <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>
              </div>
              <div class="col"></div>
            </div>

            <!-- Logo Preview -->
            <div class="row mb-3" *ngIf="form.data['id'] > 0">
              <div class="col"></div>
              <label for="preview" class="col col-form-label"
                >{{ "COMMON.PREVIEW" | translate }} :</label
              >
              <div class="col-sm-7">
                <img
                  [src]="
                    imagePreview == null
                      ? getDocThumbnail(form.data['logo'])
                      : imagePreview
                  "
                  [alt]="'COMMON.IMAGE_PREVIEW' | translate"
                  class="img-thumbnail"
                  style="max-width: 200px; max-height: 200px"
                />
              </div>
              <div class="col"></div>
            </div>

            <!-- Enable User Signup -->
            <div
              class="row mb-3 d-flex justify-content-center align-items-center"
              *ngIf="form.data['id'] > 0"
            >
              <div class="col"></div>
              <label
                for="enableUserSignup"
                class="col col-form-label d-flex justify-content-end"
              >
                <input
                  [(ngModel)]="form.data['enableUserSignup']"
                  type="checkbox"
                  class="form-check-input"
                  id="enableUserSignup"
                  name="enableUserSignup"
                />
              </label>
              <div class="col-sm-7 mt-1">
                <b>{{ "COMMON.ENABLE_USER_SIGNUP" | translate }}</b>
                <span
                  ncsTooltip
                  [title]="'COMMON.ENABLE_SIGNUP_TOOLTIP' | translate"
                >
                  <i
                    class="bi bi-question-circle fs-6 ms-2 text-secondary cursor"
                  ></i>
                </span>
              </div>
              <div class="col"></div>
            </div>

            <!-- Default Role (when signup enabled) -->
            <div
              class="row mb-3 d-flex justify-content-start"
              *ngIf="form.data['id'] > 0 && form.data['enableUserSignup']"
            >
              <div class="col"></div>
              <label for="roleId" class="col col-form-label"
                >{{ "COMMON.DEFAULT_ROLE" | translate }} :</label
              >
              <div class="col-sm-7">
                <select
                  required
                  class="form-select form-select-sm me-3"
                  id="roleId"
                  name="roleId"
                  [(ngModel)]="form.data['roleId']"
                >
                  <option selected disabled value="undefined">
                    {{ "COMMON.SELECT_ROLE" | translate }}
                  </option>
                  <option
                    *ngFor="let c of applicationRoles"
                    value="{{ c['id'] }}"
                  >
                    {{ c["name"] }}
                  </option>
                </select>
              </div>
              <div class="col ps-0">
                <span
                  ncsTooltip
                  class="d-flex float-start"
                  [title]="'COMMON.DEFAULT_ROLE_TOOLTIP' | translate"
                >
                  <i
                    class="bi bi-question-circle fs-6 ms-2 text-secondary cursor"
                  ></i>
                </span>
              </div>
            </div>

            <!-- Login Methods -->
            <div
              *ngIf="form.data['id'] > 0"
              class="row mb-3 d-flex justify-content-start"
            >
              <div class="col-2"></div>
              <label class="col-2 col-form-label"
                >{{ "COMMON.LOGIN_BY" | translate }} :</label
              >
              <div class="col-sm-7 d-flex align-items-center">
                <div class="form-check me-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="loginByEmail"
                    [(ngModel)]="form.data['loginByEmail']"
                    name="loginByEmail"
                  />
                  <label class="form-check-label" for="loginByEmail">{{
                    "APPLICATIONS.LOGIN_BY.EMAIL" | translate
                  }}</label>
                </div>
                <div class="form-check me-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="loginByMobileNo"
                    [(ngModel)]="form.data['loginByMobileNo']"
                    name="loginByMobileNo"
                  />
                  <label class="form-check-label" for="loginByMobileNo">{{
                    "APPLICATIONS.LOGIN_BY.MOBILE" | translate
                  }}</label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="loginByLoginCode"
                    [(ngModel)]="form.data['loginByLoginCode']"
                    name="loginByLoginCode"
                  />
                  <label class="form-check-label" for="loginByLoginCode">{{
                    "APPLICATIONS.LOGIN_BY.LOGIN_CODE" | translate
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          [title]="'COMMON.SAVE' | translate"
          class="ml-2"
          [disabled]="
            !uiForm.valid ||
            appUrlInvalid ||
            appname ||
            form.inputerror['subdomain']
          "
          (click)="saveData()"
        >
          <mat-icon>save</mat-icon>
          {{ "COMMON.SAVE" | translate }}
        </button>

        <button
          mat-stroked-button
          type="button"
          color="warn"
          data-bs-dismiss="modal"
          [title]="'COMMON.CLOSE' | translate"
          (click)="imagePreviewReset()"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Filter Modal -->
<div class="modal fade" id="scrollableModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ "COMMON.SEARCH" | translate }}</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row mb-3">
          <label for="name" class="col-sm-3 col-form-label"
            >{{ "COMMON.NAME" | translate }}:</label
          >
          <div class="col-sm-9">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                id="name"
                [placeholder]="'COMMON.ENTER_NAME' | translate"
                [(ngModel)]="form.searchParams['name']"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <label for="applicationCode" class="col-sm-3 col-form-label"
            >{{ "COMMON.SKEY" | translate }}:</label
          >
          <div class="col-sm-9">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                id="applicationCode"
                name="applicationCode"
                [placeholder]="'COMMON.ENTER_KEY' | translate"
                [(ngModel)]="form.searchParams['applicationCode']"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          [title]="'COMMON.APPLY_FILTER' | translate"
          (click)="search()"
        >
          {{ "COMMON.APPLY_FILTER" | translate }}
        </button>
        <button
          (click)="resetSearchForm()"
          class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          [title]="'COMMON.RESET' | translate"
        >
          <i class="fa fa-eraser" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          [title]="'COMMON.CLOSE' | translate"
          class="btn btn-outline-secondary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          data-bs-dismiss="modal"
        >
          <i class="fa fa-window-close"></i> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Developer Modal -->
<div
  class="modal fade compact-inputs dropdown-pd-none"
  id="developerModal"
  aria-hidden="true"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.ADD_DEVELOPERS" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="unSetApp()"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <app-add-collaborator
          [curApp]="selectApp"
          *ngIf="editor == 'collaborator'"
        ></app-add-collaborator>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          class="btn-sm ml-2"
          (click)="unSetApp()"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade app-role-modal"
  id="appRoleModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.APPLICATION_ROLE" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
          (click)="unSetApp()"
        ></button>
      </div>
      <div class="modal-body pt-0">
        <app-add-app-role
          [curApp]="selectApp"
          *ngIf="selectApp && editor == 'app-role'"
        ></app-add-app-role>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          class="me-3"
          data-bs-dismiss="modal"
          (click)="unSetApp()"
          [title]="'COMMON.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- App Role Usecase Modal -->
<div
  class="modal fade"
  id="appRoleUsecaseModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.ROLE_ACCESS" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="activeTab === 'role'"
              (click)="activeTab = 'role'"
            >
              {{ "ACCESS_ROLE.Role_Access" | translate }}
            </button>
          </li>

          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="activeTab === 'application'"
              (click)="activeTab = 'application'"
            >
              {{ "ACCESS_ROLE.Application_Access" | translate }}
            </button>
          </li>
        </ul>

        <!-- TAB CONTENT (Angular Controlled) -->

        <!-- ROLE ACCESS -->
        <div *ngIf="activeTab === 'role'">
          <app-add-app-role-access *ngIf="selectApp" [curApp]="selectApp">
          </app-add-app-role-access>
        </div>

        <!-- APPLICATION ACCESS -->
        <div *ngIf="activeTab === 'application'">
          <app-application-access *ngIf="selectApp" [curApp]="selectApp">
          </app-application-access>
        </div>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          class="ml-2"
          type="button"
          [title]="'COMMON.CLOSE' | translate"
          data-bs-dismiss="modal"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- App User Modal -->
<div
  class="modal fade"
  id="appUserModal"
  tabindex="-1"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-labelledby="appUserstaticBackdropLabel"
>
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.APPLICATION_MEMBERS" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="unSetApp()"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <app-application-users
          [curApp]="selectApp"
          *ngIf="selectApp && editor == 'app-user'"
        ></app-application-users>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm ml-2"
          (click)="unSetApp()"
          data-bs-dismiss="modal"
          [title]="'COMMON.CLOSE' | translate"
        >
          <i class="fa fa-window-close"></i> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>